import React, { createContext, ReactNode } from "react";
import { getAvailableSubdomain, subdomainTypes } from "./availableSubdomains";

export const getSubdomain = () => {
  const { host } = window.location;
  const testingURLs = [
    "feature-fbdev-1201-add-clearance-to-home-page.d23pf0wp3596c4.amplifyapp.com",
  ];

  // Testing cases
  if (testingURLs.includes(host)) {
    return subdomainTypes.NZ;
  }

  // General cases
  const subdomain = host.split(".")[0];
  return getAvailableSubdomain(subdomain);
};

export interface IContext {
  appBranch: subdomainTypes | "";
}

interface IContextAppProps {
  children?: ReactNode;
}

const defaultContext: IContext = {
  appBranch: "",
};

export const Context = createContext<IContext>(defaultContext);

const ContextApp = ({ children }: IContextAppProps) => {
  const appBranch = getSubdomain();

  return <Context.Provider value={{ appBranch }}>{children}</Context.Provider>;
};

export default ContextApp;
